import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/join6.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/leaderboard.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/play1.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/play2.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/play3.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/about/page.module.css");
